module.exports = __webpack_public_path__ + "media/1x1/th-904dd785.svg";